import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { features } from "@/mocks/home";

export default function FeatureGrid() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="平台功能"
            title="黑料平台功能一览，六件事就能说清"
            description="功能设计围绕「看得快、跟得上、看得懂」展开，把爆料、吃瓜和深扒串成一条顺畅的使用路径。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 70}>
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-background-100/60">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${feature.icon} text-xl`} />
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                    {feature.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {feature.desc}
                </p>
                <span className="mt-6 inline-flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  了解详情
                  <i className="ri-arrow-right-line" />
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}